import React from "react";
import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import useDocMeta from "../hooks/useDocMeta";
import ContactSection from "../components/ContactSection";
import HeroCover, { LOGOS } from "../components/HeroCover";
import { TEAM_PAGE, META } from "../mock";
import TEAM from "../data/team.json";

// Same order as the original page: DVA, Medicare, NDIS
const TEAM_LOGOS = ["Veterans", "Medicare", "NDIS"].map((k) => LOGOS.find((l) => l.alt.includes(k)));
const TEAL = "#017477";

function MemberCard({ m }) {
  const to = `/about/team/${m.slug}`;
  return (
    <article
      data-testid={`team-card-${m.slug}`}
      className="reveal bg-white rounded-[3px] overflow-hidden shadow-[0_0_10px_0_rgba(0,0,0,0.15)] flex flex-col"
    >
      <Link to={to} className="relative block aspect-[2/3] overflow-hidden" aria-label={m.name}>
        <img src={m.image} alt={m.name} loading="lazy" className="h-full w-full object-cover object-top" />
        <span
          className="absolute top-1 right-1 rounded-full px-3 py-[6px] text-[10px] leading-none uppercase text-white font-[Montserrat]"
          style={{ backgroundColor: TEAL }}
        >
          {m.role}
        </span>
      </Link>
      <div className="px-3 pt-4 pb-5 text-center">
        <h3 className="font-[Cinzel] text-[20px] leading-tight">
          <Link to={to} style={{ color: TEAL }} className="hover:opacity-80 transition-opacity">{m.name}</Link>
        </h3>
        <Link
          to={to}
          data-testid={`team-readmore-${m.slug}`}
          style={{ color: TEAL }}
          className="mt-3 inline-block font-[Montserrat] text-[11.5px] font-medium uppercase hover:opacity-80 transition-opacity"
        >
          Read More
        </Link>
      </div>
    </article>
  );
}

export default function Team() {
  useReveal();
  useDocMeta(META.team);
  return (
    <div>
      <HeroCover
        title={TEAM_PAGE.title}
        subtitle=""
        bullets={TEAM_PAGE.bullets}
        badges={[]}
        image={TEAM_PAGE.heroImage}
        showRibbon={false}
        showReview={false}
        inlineLogos={TEAM_LOGOS}
      />

      <section className="py-12 sm:py-14 bg-white">
        <div className="max-w-[1100px] mx-auto px-5">
          <h2 className="text-center font-[Jost] font-medium uppercase text-black text-[26px] tracking-[0.11em] mb-9 reveal">
            {TEAM_PAGE.gridTitle}
          </h2>
          <div className="grid grid-cols-1 min-[480px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-[30px]" data-testid="team-grid">
            {TEAM.map((m) => (
              <MemberCard key={m.slug} m={m} />
            ))}
          </div>
        </div>
      </section>

      <ContactSection />
    </div>
  );
}
